export default (): string => {
    return `admin/__`;
};
